import { Auth } from 'aws-amplify'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const challenge = searchParams.get('challenge')
  const email = searchParams.get('email')

  const verifySession = async () => {
    try {
      await Auth.currentSession()
    } catch (e) {
      await Auth.signOut({ global: false })
      navigate('/')
    }
  }

  useEffect(() => {
    if (challenge && email) return
    verifySession()
  })

  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node,
}

export default ProtectedRoute
